import React, { useState } from 'react';
import { ChevronRight, Download, Printer, Filter, Search, FileText, Calendar, Users } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FormationDecisionsArchive() {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterDate, setFilterDate] = useState('');
  const [filterType, setFilterType] = useState('');
  const [filterAuthority, setFilterAuthority] = useState('');
  // Mock data for formation decisions
  const formationDecisions = [{
    id: 1,
    decisionNumber: 'DEC-2023-001',
    committee: 'لجنة الحوكمة',
    type: 'رئيسية',
    date: '2023-01-15',
    authority: 'مجلس الإدارة',
    authorizedBy: 'أحمد الظاهري',
    status: 'منفذ',
    document: 'governance_committee_formation.pdf'
  }, {
    id: 2,
    decisionNumber: 'DEC-2023-002',
    committee: 'لجنة المالية',
    type: 'قياسية',
    date: '2023-02-10',
    authority: 'الإدارة التنفيذية',
    authorizedBy: 'محمد الهاشمي',
    status: 'منفذ',
    document: 'finance_committee_formation.pdf'
  }, {
    id: 3,
    decisionNumber: 'DEC-2023-003',
    committee: 'فريق حوكمة مجلس الإدارة',
    type: 'لجنة فرعية',
    date: '2023-03-05',
    authority: 'لجنة الحوكمة',
    authorizedBy: 'عائشة المنصوري',
    status: 'منفذ',
    document: 'board_governance_team_formation.pdf'
  }, {
    id: 4,
    decisionNumber: 'DEC-2023-004',
    committee: 'لجنة الموارد البشرية',
    type: 'قياسية',
    date: '2023-03-20',
    authority: 'الإدارة التنفيذية',
    authorizedBy: 'فاطمة الزعابي',
    status: 'منفذ',
    document: 'hr_committee_formation.pdf'
  }, {
    id: 5,
    decisionNumber: 'DEC-2023-005',
    committee: 'لجنة تقنية المعلومات',
    type: 'قياسية',
    date: '2023-04-12',
    authority: 'الإدارة التنفيذية',
    authorizedBy: 'عمر الشامسي',
    status: 'منفذ',
    document: 'it_committee_formation.pdf'
  }, {
    id: 6,
    decisionNumber: 'DEC-2023-006',
    committee: 'فريق الامتثال التنظيمي',
    type: 'لجنة فرعية',
    date: '2023-05-08',
    authority: 'لجنة الحوكمة',
    authorizedBy: 'خالد المزروعي',
    status: 'منفذ',
    document: 'regulatory_compliance_team_formation.pdf'
  }, {
    id: 7,
    decisionNumber: 'DEC-2023-007',
    committee: 'لجنة ضمان الجودة',
    type: 'قياسية',
    date: '2023-06-15',
    authority: 'الإدارة التنفيذية',
    authorizedBy: 'نورة السويدي',
    status: 'منفذ',
    document: 'quality_assurance_committee_formation.pdf'
  }];
  // Filter decisions based on search and filter criteria
  const filteredDecisions = formationDecisions.filter(decision => {
    return (searchTerm === '' || decision.committee.toLowerCase().includes(searchTerm.toLowerCase()) || decision.decisionNumber.toLowerCase().includes(searchTerm.toLowerCase())) && (filterDate === '' || decision.date.includes(filterDate)) && (filterType === '' || decision.type === filterType) && (filterAuthority === '' || decision.authority === filterAuthority);
  });
  // Get unique values for filter dropdowns
  const uniqueTypes = [...new Set(formationDecisions.map(d => d.type))];
  const uniqueAuthorities = [...new Set(formationDecisions.map(d => d.authority))];
  return <div dir="rtl" data-id="element-775">
      <div className="flex items-center mb-6" data-id="element-776">
        <Link to="/committees" className="flex items-center text-gray-600 hover:text-gray-900 ml-4" data-id="element-777">
          <ChevronRight size={20} className="ml-1" data-id="element-778" />
          العودة إلى اللجان
        </Link>
        <h1 className="text-2xl font-bold" data-id="element-779">أرشيف قرارات التشكيل</h1>
      </div>
      <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-780">
        <div className="text-gray-600 mb-4" data-id="element-781">
          <p data-id="element-782">
            يحتوي هذا الأرشيف على جميع القرارات التاريخية المتعلقة بتشكيلات
            اللجان. استخدم الفلاتر أدناه لتضييق نطاق البحث.
          </p>
        </div>
        {/* Search and Filters */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6" data-id="element-783">
          <div className="md:col-span-2" data-id="element-784">
            <div className="relative" data-id="element-785">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} data-id="element-786" />
              <input type="text" placeholder="البحث باسم اللجنة أو رقم القرار..." className="w-full pr-4 pl-10 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-787" />
            </div>
          </div>
          <div data-id="element-788">
            <div className="relative" data-id="element-789">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-790">
                التاريخ
              </label>
              <input type="date" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={filterDate} onChange={e => setFilterDate(e.target.value)} data-id="element-791" />
            </div>
          </div>
          <div data-id="element-792">
            <div className="relative" data-id="element-793">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-794">
                نوع اللجنة
              </label>
              <select className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={filterType} onChange={e => setFilterType(e.target.value)} data-id="element-795">
                <option value="" data-id="element-796">جميع الأنواع</option>
                {uniqueTypes.map((type, index) => <option key={index} value={type} data-id="element-797">
                    {type}
                  </option>)}
              </select>
            </div>
          </div>
          <div data-id="element-798">
            <div className="relative" data-id="element-799">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-800">
                جهة القرار
              </label>
              <select className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={filterAuthority} onChange={e => setFilterAuthority(e.target.value)} data-id="element-801">
                <option value="" data-id="element-802">جميع الجهات</option>
                {uniqueAuthorities.map((authority, index) => <option key={index} value={authority} data-id="element-803">
                    {authority}
                  </option>)}
              </select>
            </div>
          </div>
        </div>
        {/* Results Table */}
        <div className="overflow-x-auto" data-id="element-804">
          <table className="w-full" data-id="element-805">
            <thead data-id="element-806">
              <tr className="bg-gray-50" data-id="element-807">
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-808">
                  رقم القرار
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-809">
                  اللجنة
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-810">
                  النوع
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-811">
                  التاريخ
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-812">
                  الجهة
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-813">
                  المفوض
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-814">
                  الإجراءات
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-815">
              {filteredDecisions.map(decision => <tr key={decision.id} className="hover:bg-gray-50" data-id="element-816">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-817">
                    <div className="font-medium text-gray-900" data-id="element-818">
                      {decision.decisionNumber}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-819">
                    <div className="font-medium text-gray-900" data-id="element-820">
                      {decision.committee}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-821">
                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${decision.type === 'رئيسية' ? 'bg-blue-100 text-blue-800' : decision.type === 'لجنة فرعية' ? 'bg-purple-100 text-purple-800' : 'bg-green-100 text-green-800'}`} data-id="element-822">
                      {decision.type}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-823">
                    <div className="flex items-center" data-id="element-824">
                      <Calendar size={16} className="text-gray-500 ml-2" data-id="element-825" />
                      <span data-id="element-826">{decision.date}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-827">
                    {decision.authority}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-828">
                    {decision.authorizedBy}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-829">
                    <div className="flex space-x-3" data-id="element-830">
                      <button className="text-blue-500 hover:text-blue-700 ml-3" title="عرض القرار" data-id="element-831">
                        <FileText size={18} data-id="element-832" />
                      </button>
                      <button className="text-green-500 hover:text-green-700 ml-3" title="تنزيل" data-id="element-833">
                        <Download size={18} data-id="element-834" />
                      </button>
                      <button className="text-purple-500 hover:text-purple-700" title="طباعة" data-id="element-835">
                        <Printer size={18} data-id="element-836" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        {filteredDecisions.length === 0 && <div className="text-center py-8" data-id="element-837">
            <p className="text-gray-500" data-id="element-838">
              لا توجد قرارات تشكيل تطابق معايير البحث الخاصة بك.
            </p>
          </div>}
      </div>
    </div>;
}